<template>
  <div class="pa-2">
    <apexchart :height="chartHeight" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { toEur } from '@/mixins/filter';

export default {
  name: 'DashboardPieChart',
  props: {
    item: {},
    type: {}
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapState('sshcp', ['dashboard', 'budgetChart']),
    budget() {
      let budget = [];
      for (const property in this.budgetChart) {
        let arr = property.split('_');
        for (let i = 0; i < arr.length; i++) {
          arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }
        let name = arr.join(' ');
        budget.push({
          name: name,
          amount: this.budgetChart[property]
        });
      }
      return budget;
    },
    colors() {
      if (this.type === 'budget') {
        return ['#ff5d73', '#8a84e2', '#a3f4ff', '#fbb13c'];
      } else {
        return ['#c854b0', '#F2994A', '#98ECFF', '#EB92BE', '#6F69AC'];
      }
    },
    chartOptions() {
      let key = null;
      if (this.type !== 'budget') {
        key = this.dashboard?.formRequestPerActivity?.map(
          item => item.activity
        );
      } else {
        key = this.budget?.map(item => item.name);
      }
      const labels = key;
      return {
        chart: {
          type: 'donut',
          toolbar: {
            tools: {
              download: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false
            }
          }
        },
        legend: {
          show: true,
          position: 'right'
          // position: this.type === 'budget' ? 'bottom' : 'right',
          // horizontalAlign: this.type === 'budget' ? 'left' : 'center'
          // formatter: function(seriesName) {
          //   return [
          //     seriesName,
          //     seriesName === 'Total Submitted'
          //       ? '(Submitted, Approval Process, Fully Approved)'
          //       : ''
          //   ];
          // }
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: [0],
          offsetY: -15,
          background: {
            enabled: false
          }
        },
        labels,
        colors: this.colors,
        plotOptions: {
          pie: {
            donut: {
              size: '0'
            }
          }
        },
        tooltip: {
          y: {
            formatter: val => {
              if (this.type === 'activityRequest') return val;
              return val + ' MIDR';
            }
          }
        }
      };
    },
    series() {
      let items = null;
      if (this.type === 'activityRequest') {
        items = this.dashboard?.formRequestPerActivity?.map(
          item => item.number_of_requests
        );
      } else if (this.type === 'activityAmount') {
        items = this.dashboard?.formRequestPerActivity?.map(
          item => +toEur(item.amount_budget)
        );
      } else {
        items = this.budget?.map(item => +toEur(item.amount));
      }
      return items;
    },
    chartHeight() {
      if (this.type === 'budget') return '214';
      return '200';
    }
  }
};
</script>
